import { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { useAuth } from '../../../contexts/AuthContext';

const LoginForm = ({ onSuccess }) => {
  const { signIn } = useAuth();
  const [formData, setFormData] = useState({
    email: 'superadmin@diskarte.ph',
    password: 'SuperAdmin2026!',
    rememberMe: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    // Clear error when user starts typing
    if (errors?.[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData?.email?.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    
    if (!formData?.password) {
      newErrors.password = 'Password is required';
    } else if (formData?.password?.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    
    if (!validateForm()) return;
    
    setIsLoading(true);
    setErrors({});
    
    try {
      const { data, error } = await signIn(formData?.email, formData?.password);
      
      if (error) {
        setErrors({ form: error?.message || 'Login failed. Please check your credentials.' });
        setIsLoading(false);
        return;
      }
      
      if (data?.user) {
        console.log('Authentication successful:', {
          id: data?.user?.id,
          email: data?.user?.email,
          provider: 'email'
        });
        setIsLoading(false);
        onSuccess?.(data?.user);
      }
    } catch (error) {
      setErrors({ form: 'An unexpected error occurred. Please try again.' });
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-[18px]">
      {/* Form Error Message */}
      {errors?.form && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
          {errors?.form}
        </div>
      )}

      {/* Email/Phone Input */}
      <Input
        type="text"
        name="email"
        label="Email or Phone Number"
        placeholder="juan@example.com or 09171234567"
        value={formData?.email}
        onChange={handleChange}
        error={errors?.email}
        required
      />

      {/* Password Input */}
      <div className="relative">
        <Input
          type={showPassword ? 'text' : 'password'}
          name="password"
          label="Password"
          placeholder="Enter your password"
          value={formData?.password}
          onChange={handleChange}
          error={errors?.password}
          required
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-[12px] top-[38px] p-[4px] text-muted-foreground hover:text-foreground transition-smooth"
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          <Icon name={showPassword ? 'EyeOff' : 'Eye'} size={18} />
        </button>
      </div>

      {/* Remember Me & Forgot Password */}
      <div className="flex items-center justify-between">
        <label className="flex items-center gap-[8px] cursor-pointer group">
          <Input
            type="checkbox"
            name="rememberMe"
            checked={formData?.rememberMe}
            onChange={handleChange}
          />
          <span className="text-[14px] text-foreground group-hover:text-primary transition-smooth">
            Remember me
          </span>
        </label>
        
        <a
          href="#"
          className="text-[14px] text-primary hover:underline font-medium"
        >
          Forgot Password?
        </a>
      </div>

      {/* Submit Button */}
      <Button
        type="submit"
        variant="default"
        size="lg"
        fullWidth
        loading={isLoading}
        iconName="LogIn"
        iconPosition="left"
      >
        {isLoading ? 'Logging in...' : 'Log In'}
      </Button>

      {/* Helper Text */}
      <p className="text-[13px] text-muted-foreground text-center mt-[12px]">
        Maligayang pagbabalik! (Welcome back!)
      </p>
    </form>
  );
};

export default LoginForm;